import {
    FETCH_FINANCIALSTATEMENT_BEGIN,
    FETCH_FINANCIALSTATEMENT_SUCCESS,
    FETCH_FINANCIALSTATEMENT_FAILURE,

    FETCH_FINANCIALSTATEMENTDROPDOWN_BEGIN,
    FETCH_FINANCIALSTATEMENTDROPDOWN_SUCCESS,
    FETCH_FINANCIALSTATEMENTDROPDOWN_FAILURE,

    FETCH_FINANCIALSTATEMENTDOCUMENT_BEGIN,
    FETCH_FINANCIALSTATEMENTDOCUMENT_SUCCESS,
    FETCH_FINANCIALSTATEMENTDOCUMENT_FAILURE,
  } from '../constants/financialStatement';


const initialState={
    financialStatement: {},
    fsSecurityDropdown: [],
    isLoading:false,
    fsDocuments: [],
    error:""
}


export const getFinancialStatementReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_FINANCIALSTATEMENT_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
          financialStatement:{},
        };
      }
    case FETCH_FINANCIALSTATEMENT_FAILURE:
        return {
            ...initialState,
            isLoading:false,
            financialStatement:{},
            error :payload.error
        };
    case FETCH_FINANCIALSTATEMENT_SUCCESS:
        return {
            ...initialState,
            financialStatement:payload.financialStatement,
            isLoading:false,
            error:null
         };
   
       
    default:
        return state;
 }
}

export default getFinancialStatementReducer

export const getFinancialStatementDocumentReducer = (state = initialState, action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_FINANCIALSTATEMENTDOCUMENT_BEGIN: {
        return {
            ...initialState,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_FINANCIALSTATEMENTDOCUMENT_SUCCESS:
        return {
            ...initialState,
            isLoading:false,
            fsDocuments:payload.fsDocuments,
           
        };
    case FETCH_FINANCIALSTATEMENTDOCUMENT_FAILURE:
        return {
            ...initialState,
            error:payload.error,
            isLoading:true,
        };
    default:
        return state;
 }
}
export const getFsSecurityReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
case FETCH_FINANCIALSTATEMENTDROPDOWN_BEGIN: {
    return {
        ...state,
        isLoading: true,
        error: null,
    };
}
case FETCH_FINANCIALSTATEMENTDROPDOWN_FAILURE:
    return {
        ...initialState,
        isLoading: false,
        fsSecurityDropdown: null
    };
case FETCH_FINANCIALSTATEMENTDROPDOWN_SUCCESS:
    return {
        ...initialState,
        isLoading:false,
        fsSecurityDropdown:payload.fsSecurityDropdown,
    };
    default:
        return state;
 }
}